import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
const items = [{
  title: 'The 24-Hour Travel Tactics Guide',
  desc: "The psychological 'pre-game' to lower toddler anxiety before you even leave the house."
}, {
  title: "The 'Quiet Flight' Activity Bundle",
  desc: '15 printable, no-mess sheets designed specifically for airplane tray tables.'
}, {
  title: 'The Snack Map Template',
  desc: 'A gamified eating system that turns a 2-minute snack into 30 minutes of quiet focus.'
}, {
  title: 'The R.E.S.E.T. Protocol',
  desc: 'Word-for-word scripts and actions to stop a meltdown in its tracks.'
}, {
  title: 'The SOS Packing Masterlist',
  desc: 'Exact gear for your carry-on (including the one item most parents forget that saves your clothes).'
}];
export function WhatYouGetSection() {
  return <section className="py-10 md:py-16 bg-white" data-id="element-142">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-143">
        <div className="text-center mb-10" data-id="element-144">
          <h2 className="text-2xl md:text-3xl font-bold text-brand-dark mb-3" data-id="element-145">
            Everything You Need for a Peaceful Trip
          </h2>
          <p className="text-lg text-gray-600" data-id="element-146">
            The complete toolkit to keep them engaged from takeoff to landing.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-center" data-id="element-147">
          <div className="space-y-3" data-id="element-148">
            {items.map((item, index) => <motion.div key={index} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} className="flex gap-3 p-4 bg-brand-cream rounded-xl border border-orange-50" data-id="element-149">
                <CheckCircle2 className="w-5 h-5 text-brand-orange shrink-0 mt-0.5" data-id="element-150" />
                <div data-id="element-151">
                  <h3 className="text-lg font-bold text-brand-dark mb-1" data-id="element-152">
                    {item.title}
                  </h3>
                  <p className="text-gray-600" data-id="element-153">{item.desc}</p>
                </div>
              </motion.div>)}
          </div>

          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="relative" data-id="element-154">
            <div className="absolute inset-0 bg-brand-orange/10 rounded-[2rem] transform -rotate-2 scale-105" data-id="element-155"></div>
            <img src="https://cdn.magicpatterns.com/uploads/7rZgSmfFg9qYptsw3e3Bq4/heylloyd-image-1772765598538.png" alt="Parent using the Toddler Travel Survival Kit" className="relative z-10 rounded-2xl shadow-xl w-full object-cover" data-id="element-156" />
          </motion.div>
        </div>
      </div>
    </section>;
}